import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Delete, GetApp } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';

class TableFiles extends PureComponent {
    static propTypes = {
        onDelete: PropTypes.func.isRequired,
        hasRights: PropTypes.bool.isRequired,
        onDownload: PropTypes.func.isRequired,
        theme: PropTypes.object.isRequired,
        files: PropTypes.array.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
    };

    renderData = memoizeOne(files => {
        let result = [];

        files.map(file => {
            result.push({
                filename: file,
            });
        });

        return result;
    });

    renderActions = memoizeOne(() => {
        const { history, profile, onDelete, onDownload, hasRights } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: [],
        };
        if (profile.get('admin') || userRights.includes('homeDetails')) {
            actions.row.push({
                icon: () => <GetApp color="primary" />,
                onClick: ({ filename }) => onDownload(filename),
                tooltip: Translator.translate(`general.download`),
            });

            hasRights &&
                actions.row.push({
                    icon: () => <Delete color="error" />,
                    onClick: ({ filename }) => {
                        Toastr.confirm(
                            `${Translator.translate('generic.files.table.action.delete.confirmContent')} "${filename}"`,
                            Translator.translate('generic.files.table.action.delete.confirmTitle'),
                            {
                                onYes: () => {
                                    onDelete(filename);
                                },
                            },
                        );
                    },
                    tooltip: Translator.translate(`general.delete`),
                });
        }
        return actions;
    });

    renderColumns = memoizeOne(() => {
        const { history, profile, onDownload } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.filename'),
                name: 'filename',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeDetails')) && {
                    onClick: ({ filename }) => onDownload(filename),
                    tooltip: Translator.translate(`general.download`),
                },
            },
        ];
    });

    renderTable() {
        const { files } = this.props;

        return <FHETable idTable="tableFiles" columns={this.renderColumns()} data={this.renderData(files)} actions={this.renderActions()} minified />;
    }

    render() {
        const { files, theme } = this.props;
        return (
            <Fragment>
                {files.length > 0 ? (
                    this.renderTable()
                ) : (
                    <div style={{ color: theme.palette.text.primary }}>{Translator.translate(`generic.files.table.body.emptyDataSourceMessage`)}</div>
                )}
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user,
    };
}

const styles = theme => ({
    enabled: {
        color: theme.palette.success.main,
    },
    disabled: {
        color: theme.palette.error.main,
    },
});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableFiles)));



// WEBPACK FOOTER //
// ./environments/genericEnv/components/FileManager/TableFiles.js